import { ContentActionGq } from './ContentActionGq';
import { ContentKeywordGq, ContentKeywordGqProps } from './ContentKeywordGq';
import { ContentTaskStatusGq } from './ContentTaskStatusGq';
import { ScrapedUrlGq, ScrapedUrlGqProps } from './ScrapedUrlGq';
import {
  ContentTaskTagCombinationGq,
  ContentTaskTagCombinationGqProps,
} from './ContentTaskTagCombinationGq';
import { QueuedItemStatus } from './QueuedItemStatus';

export interface ContentTaskGq {
  id: number;
  url?: string;
  scrapedUrl?: ScrapedUrlGq;
  title?: string;
  titleNew?: string;
  titleRuleBased?: string;
  titleFinal?: string;
  titleChanged: boolean;
  h1?: string;
  h1New?: string;
  h1RuleBased?: string;
  h1Final?: string;
  h1Changed: boolean;
  meta?: string;
  metaNew?: string;
  metaRuleBased?: string;
  metaFinal?: string;
  metaChanged?: boolean;
  content?: string;
  projectId: number;
  action: ContentActionGq;
  actionManual?: ContentActionGq;
  actionFinal: ContentActionGq;
  keywords: ContentKeywordGq[];
  tagCombinations: ContentTaskTagCombinationGq[];
  approvedStatus: ContentTaskStatusGq;
  approvedStatusDateTime?: string;
  comment?: string;
  chatGptStatus?: QueuedItemStatus;
  chatGptResult?: string;
}

export const ContentTaskGqProps = `
    id
    url
    scrapedUrl { ${ScrapedUrlGqProps} }
    title
    titleNew
    titleChanged
    titleRuleBased
    titleFinal
    h1
    h1New
    h1Changed
    h1RuleBased
    h1Final
    meta
    metaNew
    metaChanged
    metaRuleBased
    metaFinal
    content
    projectId
    action
    actionManual
    actionFinal
    keywords {${ContentKeywordGqProps}}
    tagCombinations {${ContentTaskTagCombinationGqProps}}
    approvedStatus
    approvedStatusDateTime
    comment
    chatGptStatus
    chatGptResult
`;
